import { viewDistanceRestoreCommandFromTextureScale } from "./map-view-controls.js";

const DEFAULT_FOCUS_VIEW_MODE = "2d";
const FOCUS_WORLD_POINT_TEXTURE_SCALE = 3;

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function trimString(value) {
  const normalized = String(value ?? "").trim();
  return normalized || "";
}

function normalizeHistoryBehavior(value) {
  const normalized = trimString(value).toLowerCase();
  return normalized === "navigate" ? "navigate" : "append";
}

function cloneJson(value) {
  return JSON.parse(JSON.stringify(value));
}

function autoAdjustViewEnabled(signals) {
  return signals?._map_ui?.windowUi?.settings?.autoAdjustView !== false;
}

export function buildFocusWorldPointSignalPatch(focusWorldPoint, signals = {}) {
  const worldX = Number(focusWorldPoint?.worldX);
  const worldZ = Number(focusWorldPoint?.worldZ);
  if (!Number.isFinite(worldX) || !Number.isFinite(worldZ)) {
    return null;
  }
  const currentToken = Number(signals?._map_actions?.focusWorldPointToken || 0);
  const characterIdentityKey = trimString(focusWorldPoint?.characterIdentityKey);
  const patch = {
    _map_actions: {
      focusWorldPoint: {
        elementKind: trimString(focusWorldPoint?.elementKind),
        characterIdentityKey,
        worldX,
        worldZ,
        pointKind: trimString(focusWorldPoint?.pointKind),
        pointLabel: trimString(focusWorldPoint?.pointLabel),
        historyBehavior: normalizeHistoryBehavior(focusWorldPoint?.historyBehavior),
      },
      focusWorldPointToken: currentToken + 1,
    },
  };
  if (!autoAdjustViewEnabled(signals)) {
    return patch;
  }

  const currentView = isPlainObject(signals?._map_session?.view)
    ? signals._map_session.view
    : {};
  const currentCamera = isPlainObject(currentView.camera) ? currentView.camera : {};
  const viewMode = trimString(currentView.viewMode) || DEFAULT_FOCUS_VIEW_MODE;
  const targetCamera =
    viewDistanceRestoreCommandFromTextureScale(
      { view: currentView },
      FOCUS_WORLD_POINT_TEXTURE_SCALE,
    )?.restoreView?.camera || cloneJson(currentCamera);
  const pointCamera =
    viewMode === "3d"
      ? { pivotWorldX: worldX, pivotWorldZ: worldZ }
      : { centerWorldX: worldX, centerWorldZ: worldZ };
  return {
    ...patch,
    _map_session: {
      view: {
        viewMode,
        camera: {
          ...targetCamera,
          ...pointCamera,
        },
      },
    },
  };
}
